module.exports = __webpack_public_path__ + "img/i-o-sss.f6f1853f.png";